import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

import { getThemeClass, getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";
import type { NavItemType } from "@/shared/types/header";

type SiteNavItemProps = {
  item: NavItemType;
  activeMenu: string | null;
  onOpen: (label: string) => void;
  onClose: () => void;
  onScheduleClose: () => void;
  onCancelClose: () => void;
};

export function SiteNavItem({
  item,
  activeMenu,
  onOpen,
  onClose,
  onScheduleClose,
  onCancelClose,
}: SiteNavItemProps) {
  const navClasses = getThemeComponentClasses().nav;

  if (!item.children && item.path) {
    return (
      <Link
        to={item.path}
        className={`text-base font-semibold ${getThemeClass(navClasses.linkColor, "text-theme-text")} ${navClasses.linkHoverColor || "hover:opacity-70"}`}
      >
        {item.label}
      </Link>
    );
  }

  const isOpen = activeMenu === item.label;

  return (
    <div
      className="relative"
      onMouseEnter={() => {
        onCancelClose();
        onOpen(item.label);
      }}
      onMouseLeave={onScheduleClose}
    >
      <button
        type="button"
        className={`flex items-center gap-1 text-base font-semibold ${getThemeClass(navClasses.linkColor, "text-theme-text")}`}
      >
        {item.label}
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen ? (
        <div className="absolute left-0 top-full z-50 pt-3" onMouseEnter={onCancelClose}>
          <div
            className={`theme-shadow-soft w-56 overflow-hidden rounded-xl border ${getThemeClass(navClasses.menuBgColor, "bg-theme-surface")} ${getThemeClass(navClasses.menuBorderColor, "border-theme-border")}`}
          >
            {item.children?.map((child) => (
              <Link
                key={child.label}
                to={child.path}
                onClick={onClose}
                className={`block px-5 py-3 text-sm font-medium transition-colors ${getThemeClass(navClasses.menuItemColor, "text-theme-text")} ${getThemeClass(navClasses.menuItemHoverBgColor, "hover:bg-theme-surface-muted")}`}
              >
                {child.label}
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
